import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    columnEmployee: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.columnEmployee",
    billableAmountMinutes: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.billableAmountMinutes",
    columnActivityDescription: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.columnActivityDescription",
    columnBillableAmount: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.columnBillableAmount",
    columnDate: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.columnDate",
    listHeader: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.time-track-entries.time-track-entries-i18n.listHeader"
};
export const translations = {
    da: {
        columnEmployee: "Medarbejder",
        billableAmountMinutes: "Debiterbar tid",
        columnActivityDescription: "Notat",
        columnBillableAmount: "Beløb",
        columnDate: "Dato",
        listHeader: "Time-/sagsposter"
    },
    en: {
        columnEmployee: "User",
        billableAmountMinutes: "Billable time",
        columnActivityDescription: "Note",
        columnBillableAmount: "Amount",
        columnDate: "Date",
        listHeader: "Time tracking entries"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        columnEmployee: t(k.columnEmployee),
        billableAmountMinutes: t(k.billableAmountMinutes),
        columnActivityDescription: t(k.columnActivityDescription),
        columnBillableAmount: t(k.columnBillableAmount),
        columnDate: t(k.columnDate),
        listHeader: t(k.listHeader)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
